import AsyncMultiSelect from './AsyncMultiSelect';

export default AsyncMultiSelect;
